import React, { useState, useEffect } from 'react'
import { Box, Tab, Tabs, CircularProgress, Badge } from "@mui/material";
import { useIntl, FormattedMessage } from "react-intl";
import { useQuery } from "@tanstack/react-query";
import { styled } from "@mui/material/styles";
import useFeatureFlags, { isFeatureEnabled } from '../../../hooks/useFeatureFlags';
import { fetchModules } from "../../../fetchers/modules";
import { fetchMachineData } from "../../../fetchers/machine";
import messages from "./messages";

const StyledTabs = styled((props) => (


    <Tabs
        {...props}
        TabIndicatorProps={{ children: <span className="MuiTabs-indicatorSpan" /> }}
    />
))({
    '& .MuiTabs-indicator': {
        display: 'flex',
        justifyContent: 'center',
        backgroundColor: 'transparent',
    },
    '& .MuiTabs-indicatorSpan': {
        width: '100%',
        backgroundColor: '#fff',
    },
});

const StyledTab = styled((props) => <Tab disableRipple {...props} />)(

    ({ theme }) => ({

        textTransform: 'none',
        fontWeight: theme.typography.fontWeightRegular,
        fontSize: theme.typography.pxToRem(20),
        marginRight: theme.spacing(0),
        minWidth: "150px",
        //backgroundColor: '#799c4a',
        color: 'rgba(255, 255, 255, 0.7)',
        '&.Mui-selected': {
            color: '#fff',
            backgroundColor: "#434957 !important",
        },
        '&.Mui-focusVisible': {
            backgroundColor: 'rgba(100, 95, 228, 0.32)',
        },
        '&.MuiTab-root': {
            backgroundColor: '#43495799',
            border: "1px solid #0c101b",
        },
    }),
);

export default function MachineTabs(props) {
    const { machineId, activitiesCount, selectedTab, setSelectedTab, alarmsCount } = props;
    const featureQuery = useFeatureFlags();
    const { formatMessage } = useIntl();

    const machineQuery = useQuery(
        ["machine", machineId],
        () => fetchMachineData(machineId),
        {
          keepPreviousData: true
        });

    const modulesQuery = useQuery(
        ["module"],
        () => fetchModules(),
        {
          staleTime: 120000,
          refetchInterval: 120000,
          keepPreviousData: true
        }
    );

    const activitiesEnabled = modulesQuery.data?.enabledModules.find(module => module.id === "activities") !== undefined;

    const handleTabChange = (event, newValue) => {
        setSelectedTab(newValue);
    };

    if (featureQuery.isLoading || modulesQuery.isLoading) {
        return <div style={{display: 'flex',  justifyContent:'center', alignItems:'center', height: '100vh'}}><CircularProgress color="secondary" /></div>;
    }

    var showOnlyActivities = false;
    if (machineQuery.data?.machineType?.showInActivitySpecialList === true && selectedTab !== 2) {
        showOnlyActivities = true;
        handleTabChange(null, 2);
    }
    return (
      <Box sx={{ width: '100%' }} >
        <Box>
          <StyledTabs value={selectedTab} onChange={handleTabChange} aria-label="styled tabs example">
            { showOnlyActivities ? <StyledTab label={formatMessage(messages.uncodedStopsAndOpenActivities)} disabled /> : <StyledTab label={formatMessage(messages.uncodedStopsAndOpenActivities)} /> }
            { showOnlyActivities ? <StyledTab label={formatMessage(messages.tabMachineStops)} disabled /> : <StyledTab label={formatMessage(messages.tabMachineStops)} /> }
            { activitiesEnabled ? <StyledTab label={<Badge badgeContent={activitiesCount} color="warning" ><FormattedMessage {...messages.tabActivities} /></Badge>} /> : <StyledTab label={formatMessage(messages.tabActivities)} disabled />  }
            { showOnlyActivities ? <StyledTab label={formatMessage(messages.tabTakt)} disabled /> : <StyledTab label={formatMessage(messages.tabTakt)} />}
            { showOnlyActivities ? <StyledTab label={formatMessage(messages.tabSensorData)} disabled /> : isFeatureEnabled(featureQuery, "SensorData") ? <StyledTab label={formatMessage(messages.tabSensorData)} /> : <StyledTab label={formatMessage(messages.tabSensorData)} disabled />  }
            { showOnlyActivities ? <StyledTab label={formatMessage(messages.tabAlarms)} disabled /> : isFeatureEnabled(featureQuery, "SensorData") ? <StyledTab label={<Badge badgeContent={alarmsCount} color="warning" ><FormattedMessage {...messages.tabAlarms} /></Badge>} /> : <StyledTab label={formatMessage(messages.tabAlarms)} disabled />  }
          </StyledTabs>
        </Box>
      </Box>
    );
}